import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/roboto-flex";
import App from "./App";
import "./index.css";

// Get root element
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// Render app
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
